import React, { useState, useEffect } from 'react';

function VersionPage() {
  const [version, setVersion] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchVersion = async () => {
      try {
        const response = await fetch('/version');
        if (!response.ok) {
          throw new Error('Failed to fetch version');
        }
        const versionText = await response.text();
        setVersion(versionText);
      } catch (error) {
        console.error('Error fetching version:', error);
        setError(error.message);
      }
    };

    fetchVersion();
  }, []);

  return (
    <div style={{ padding: '20px' }}>
      <h1>Application Version</h1>
      {version && <p>Server Version: {version}</p>}
      {error && <p style={{ color: 'red' }}>Error: {error}</p>}
    </div>
  );
}

export default VersionPage;
